import React, { useState } from "react"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import { useDispatch } from "react-redux"
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    Label,
    Input,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    Row,
} from "reactstrap"
import {
    getTokenFromLocalStorage,
    showErrorMessages,
    hasPermission,
} from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { updateCahoutPercentage } from "helpers/repository"

export default function Cashout(props) {
    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(false)
    const [selectedeCashoutData, setSelectedCashoutData] = useState(null)
    const [updateSelectedCashoutValue, setUpdateSelectedCashoutValue] = useState(null)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    const handleEditSelectedCashoutValue = (data) => {
        setSelectedCashoutData(data)
        setUpdateSelectedCashoutValue(data?.value)
        toggle()
    }

    const handleSubmit = e => {
        e.preventDefault()

        const data = {
            type: selectedeCashoutData?.type,
            value: updateSelectedCashoutValue
        }

        updateCahoutPercentage(selectedeCashoutData.id, data)
            .then(function (response) {
                //handle success
                showMessage("success", response.data.message)
                dispatch(getAllRiskManagementSetting())
            })
            .catch(function (response) {
                //handle error
                showErrorMessages(response)
            })

        toggle()
    }
   

    return (
        <React.Fragment>
            <Col>
                <Card>
                    <CardBody>
                        <CardTitle className="mb-4">Cashout</CardTitle>

                        <Form>
                            {props?.data?.map((cashout) => (

                                <div className="row mb-4" key={cashout.id}>
                                    <Col xs={6} sm={4} md={4} lg={6}>
                                        <Label className="col-form-label">{cashout?.type}</Label>
                                    </Col>
                                    <Col xs={6} sm={8} md={8} lg={6}>
                                        <div className="d-flex align-items-center gap-3">
                                            <p className="text-muted fw-medium col-form-label">
                                                {cashout?.value}
                                            </p>
                                            {hasPermission("update-parameters") && <span
                                                onClick={() => handleEditSelectedCashoutValue(cashout)}
                                                style={{ width: "28px", height: "28px", cursor: "pointer" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M505 122.9L517.1 135C526.5 144.4 526.5 159.6 517.1 168.9L488 198.1L441.9 152L471 122.9C480.4 113.5 495.6 113.5 504.9 122.9zM273.8 320.2L408 185.9L454.1 232L319.8 366.2C316.9 369.1 313.3 371.2 309.4 372.3L250.9 389L267.6 330.5C268.7 326.6 270.8 323 273.7 320.1zM437.1 89L239.8 286.2C231.1 294.9 224.8 305.6 221.5 317.3L192.9 417.3C190.5 425.7 192.8 434.7 199 440.9C205.2 447.1 214.2 449.4 222.6 447L322.6 418.4C334.4 415 345.1 408.7 353.7 400.1L551 202.9C579.1 174.8 579.1 129.2 551 101.1L538.9 89C510.8 60.9 465.2 60.9 437.1 89zM152 128C103.4 128 64 167.4 64 216L64 488C64 536.6 103.4 576 152 576L424 576C472.6 576 512 536.6 512 488L512 376C512 362.7 501.3 352 488 352C474.7 352 464 362.7 464 376L464 488C464 510.1 446.1 528 424 528L152 528C129.9 528 112 510.1 112 488L112 216C112 193.9 129.9 176 152 176L264 176C277.3 176 288 165.3 288 152C288 138.7 277.3 128 264 128L152 128z" /></svg>
                                            </span>}
                                        </div>
                                    </Col>
                                </div>
                            ))}
                        </Form>
                    </CardBody>
                </Card>
            </Col>

            <Modal centered isOpen={isOpen} toggle={toggle}>
                <ModalHeader tag="h4" toggle={toggle}>
                    {"Update Cashout"}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            {/* <Label htmlFor="send_sms_Input" style={{ textTransform: "uppercase" }}>{`Update ${selectedeCashoutData?.type} `}</Label> */}
                            <Row>

                                <div className="mb-3">
                                    <Col lg={12}>
                                        <Label htmlFor="cashout_input" style={{textTransform: "uppercase"}}>
                                            {selectedeCashoutData?.type}
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="cashout_input"
                                            name={"updateSelectedCashoutValue"}
                                              value={updateSelectedCashoutValue}
                                            required
                                            onChange={e => {
                                                setUpdateSelectedCashoutValue(e.target.value)
                                            }}
                                        />
                                    </Col>
                                </div>

                            </Row>
                        </div>



                        <div className="text-end">
                            <Button type="submit" className="btn btn-success w-md">
                                Save
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}
